import SurveyRewardsSummary from './SurveyRewardsSummary';
export default SurveyRewardsSummary; 